import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  criarLcp116Prefeitura,
  criarCategoriaLcp116Prefeitura,
  inserirOuAtualizar,
} from "../../DataSources";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  codigo: undefined,
  categoriaId: undefined,
  localTributacao: undefined,
  descricao: "",
};

export default class Lcp116PrefeituraForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    this.lcp116PrefeituraDs = criarLcp116Prefeitura();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.categoriaLcp116Options = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "NENHUM",
      dataSource: criarCategoriaLcp116Prefeitura(),
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    this.localTributacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "NENHUM",
      dataSource: [
        { id: 0, descricao: "Local de Serviço" },
        { id: 1, descricao: "Sede Prestador" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.lcp116PrefeituraDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("LCP116 não encontrado.", "error");
              this.props.history.push("/lcp116prefeitura");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;

    // if (this.props.match.params.id === undefined) {
    //   this.setState({ ...template });
    // }
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={3}>
            <GroupItem caption="LCP 116/2003" colSpan={3} colCount={3}>
              <SimpleItem dataField={"codigo"}>
                <Label text="Código" />
              </SimpleItem>
              <SimpleItem
                dataField={"categoriaId"}
                editorType={"dxSelectBox"}
                editorOptions={this.categoriaLcp116Options}
              >
                <Label text="Categoria" />
              </SimpleItem>
              <SimpleItem
                dataField={"localTributacao"}
                editorType={"dxSelectBox"}
                editorOptions={this.localTributacaoOptions}
              >
                <Label text="Local de Tributação" />
              </SimpleItem>
              <SimpleItem
                dataField={"descricao"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "50px" }}
                colSpan={3}
              >
                <Label text="Descrição" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.lcp116PrefeituraDs, entidade)
      .then(
        function () {
          notify("LCP116 cadastrada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
